import styled from 'styled-components';
import { IconButton } from 'modules/IconButton';
import { BREADCRUMB_MARGIN } from '../styled';
export const StyledIconButton = styled(IconButton) `
  position: relative;
  margin-right: ${BREADCRUMB_MARGIN};

  [data-icon='falcon'] {
    width: 1rem;
    height: 1rem;
  }
`;
